import React, { useState } from 'react';
import style from './AccordionComponent.module.css';

const AccordionComponent = ({ title, description }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className={`${style.component} ${open && style.componentOpen}`}>
      <button className={style.title} onClick={() => setOpen(!open)}>
        <img src="/react/phosphor/caret-down-bold.svg" height="14" width="14" />
        <span>{title}</span>
      </button>
      <div className={style.description}>
        {description}
      </div>
    </div>
  );
};

export default AccordionComponent;